import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";

import Cookies from "js-cookie";

import Form from "react-bootstrap/Form";

import ConfirmationModal from "../confirmationModal/confirmationModal";

import { loginFirstLogin } from "../../../../redux/loginReduser/actionLogin";

import eye_off from "../../../../resourсes/eye-off.svg";
import eye from "../../../../resourсes/eye.svg";

import styles from "../LoginPage.module.css";

const FirstLoginPage = () => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    setError,
    formState: { errors },
  } = useForm();
  const loginData = useSelector((state) => state.authLoginReducer.authData);
  const [showModal, setShowModal] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const onSubmit = (data) => {
    const { password, confirmPassword } = data;

    if (password !== confirmPassword) {
      setError("confirmPassword", {
        type: "passwordMismatch",
        message: "Пароли не совпадают.",
      });
      return;
    }

    const login = Cookies.get("login");

    dispatch(
      loginFirstLogin({
        login: login,
        password: password,
        confirmPassword: confirmPassword,
      }),
    );
  };

  useEffect(() => {
    if (loginData.message) {
      setShowModal(true);
    }
  }, [loginData]);

  return (
    <>
      <div className={styles["form-container"]}>
        <div className={styles["img-block"]}></div>
        <Form
          className={styles["login-form"]}
          onSubmit={handleSubmit(onSubmit)}
        >
          <h3 className={styles["form-header"]}>Обновите пароль</h3>
          <Form.Group className="mb-3" controlId="formFirstBasicPassword">
            <Form.Label className={styles["text-form"]}>
              Новый пароль
            </Form.Label>
            <div className={styles["input-group"]}>
              <Controller
                name="password"
                control={control}
                defaultValue=""
                rules={{
                  required: "Введите пароль",
                  minLength: {
                    value: 10,
                    message: "Пароль должен содержать не менее 10 символов.",
                  },
                }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                    type={showPassword ? "text" : "password"}
                    placeholder="Введите пароль"
                    className={styles["form-input"]}
                  />
                )}
              />
              <div className={styles["input-group-img-block"]}>
                <img
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ cursor: "pointer" }}
                  src={showPassword ? eye_off : eye}
                  alt={"showPassword"}
                />
              </div>
            </div>
            {errors.password && (
              <Form.Text className="text-danger">
                {errors.password.message}
              </Form.Text>
            )}
          </Form.Group>

          <Form.Group
            className="mb-3"
            controlId="formFirstBasicConfirmPassword"
          >
            <Form.Label className={styles["text-form"]}>
              Подтверждение пароля
            </Form.Label>
            <div className={styles["input-group"]}>
              <Controller
                name="confirmPassword"
                control={control}
                defaultValue=""
                rules={{
                  required: "Подтвердите пароль",
                  minLength: {
                    value: 10,
                    message: "Пароль должен содержать не менее 10 символов.",
                  },
                }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Введите пароль"
                    className={styles["form-input"]}
                  />
                )}
              />
              <div className={styles["input-group-img-block"]}>
                <img
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={{ cursor: "pointer" }}
                  src={showConfirmPassword ? eye_off : eye}
                  alt={"showConfirmPassword"}
                />
              </div>
            </div>
            {errors.confirmPassword && (
              <Form.Text className="text-danger">
                {errors.confirmPassword.message}
              </Form.Text>
            )}
          </Form.Group>

          <button type="submit" className={styles["login-button-form"]}>
            ВХОД
          </button>
        </Form>
      </div>
      <ConfirmationModal
        show={showModal}
        message={loginData.message}
        onConfirm={() => setShowModal(false)}
        onHide={() => setShowModal(false)}
      />
    </>
  );
};

export default FirstLoginPage;
